function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 12.385L6.5 14 0 7l6.5-7L8 1.615 3 7l5 5.385z",
  fill: "#333"
});

function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBackArrow;